import React from 'react'
import { motion } from 'framer-motion'

export default function PageLoader() {
  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
      <motion.div
        animate={{
          scale: [1, 1.2, 1],
          rotate: [0, 180, 360]
        }}
        transition={{
          repeat: Infinity,
          duration: 2,
          ease: "easeInOut"
        }}
        className="w-16 h-16 bg-gradient-primary rounded-2xl shadow-glow-pink"
      ></motion.div>
    </div>
  )
}
